import React from 'react'
import { P } from '../../styles/Elements'
import Separator from '../../styles/Separator'
import StandardVerticalSpace from '../../styles/StandardVerticalSpace'
import { DolaThemes } from '../../styles/types'
import { Content } from './styles'

interface SubtitleProps {
  bottomOnly?: boolean
  rightItem?: React.ReactChild
  topOnly?: boolean
  subtitle?: React.ReactChild
  theme?: DolaThemes
}

const Subtitle: React.FC<SubtitleProps> = ({
  subtitle,
  bottomOnly,
  rightItem,
  theme = 'light',
  topOnly,
}) => {
  return (
    <>
      {!bottomOnly && (
        <>
          <Separator dolaTheme={theme} />
          <StandardVerticalSpace />
        </>
      )}
      <Content>
        <div>
          <P className="subtitle">{subtitle}</P>
        </div>
        <div>{rightItem}</div>
      </Content>
      {!topOnly && (
        <>
          <StandardVerticalSpace />
          <Separator dolaTheme={theme} />
        </>
      )}
    </>
  )
}

export default Subtitle
